const FEATURE_HELP_URLS = {
  agent_bots: 'https://chatlotta.se/help/agent-bots',
  agents: 'https://chatlotta.se/help/agents',
  audit_logs: 'https://chatlotta.se/help/audit-logs',
  campaigns: 'https://chatlotta.se/help/campaigns',
  canned_responses: 'https://chatlotta.se/help/canned',
  channel_email: 'https://chatlotta.se/help/email',
  channel_facebook: 'https://chatlotta.se/help/fb',
  custom_attributes: 'https://chatlotta.se/help/custom-attributes',
  dashboard_apps: 'https://chatlotta.se/help/dashboard-apps',
  help_center: 'https://chatlotta.se/help/help-center',
  inboxes: 'https://chatlotta.se/help/inboxes',
  integrations: 'https://chatlotta.se/help/integrations',
  labels: 'https://chatlotta.se/help/labels',
  macros: 'https://chatlotta.se/help/macros',
  reports: 'https://chatlotta.se/help/reports',
  sla: 'https://chatlotta.se/help/sla',
  team_management: 'https://chatlotta.se/help/teams',
  webhook: 'https://chatlotta.se/help/webhooks',
  billing: 'https://chatlotta.se/pricing',
  saml: 'https://chatlotta.se/help/saml',
  captain_billing: 'https://chatlotta.se/help/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
